import { Component, OnInit,ElementRef, ViewChild,Renderer2 } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { LoginComponent } from "../../modals/login/login.component";
import { ResetPasswordComponent } from "../../modals/reset-password/reset-password.component";
import { TranslateService } from "@ngx-translate/core";
import { AuthServiceService } from "../../services/auth_services/auth-service.service";
import { register_pObj } from "../../services/payload/register_pobj";
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { StorageServicesService } from '../../services/storage_services/storage-services.service';
import { BookOfRulesPage } from "../../pages/book-of-rules/book-of-rules.page";
import {TermsAndConditionsComponent} from "../../modals/terms-and-conditions/terms-and-conditions.component";
import { LoadingController } from '@ionic/angular';
import {Filter} from 'profanity-check'

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
})
export class RegistrationComponent implements OnInit {
  @ViewChild('flug') flug: ElementRef;
  @ViewChild('countryname') countryname: ElementRef;
  defaultFilter: Filter;


  constructor(
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public modalController: ModalController,
    public renderer:Renderer2,
    private storageService: StorageServicesService,
    translate: TranslateService,
    public ele:ElementRef,
    public alertController: AlertController,
    private loadingController: LoadingController,
    public auth: AuthServiceService
  ) {
    //translate.use("en");
    this.defaultFilter = new Filter()

  }

  regform:FormGroup;
  regform2:FormGroup;
  regform3:FormGroup;

  get errorControl() {
    return this.regform.controls;
  }

  get errorControl2() {
    return this.regform2.controls;
  }

  get errorControl3() {
    return this.regform3.controls;
  }

  step1: boolean = true;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;

  title:string="Mr";
  withdrawFromBank: boolean=false;
  country: string="Lk";
  phoneCountryCode: string="94";
  countryCode: string="LK";
  currencyCode: string="LKR";
  emailAddress: string;
  pinNumber: string;
  accountNumber: number;
  firstName: string;
  surname: string;
  idNumber: number;
  address1: string;
  address2: string;
  suburb: string;
  postalCode: number ;
  email: string;
  phoneNumber: number ;
  agreeToTerms: boolean;
  cardType: string="SHOP";
  cardNumber: string="";
  cardExpireDate: any=null;
  cardExpireDateMMYY: any=null;
  cardSecurityCode: any=null;
  balance: number=0;
  customerIdType: string="NID";
  customerIdReference: string="N/A";
  
  // @ViewChild('nicFrontInput') nicFrontInput!: ElementRef<HTMLInputElement>;
  // @ViewChild('nicBackInput') nicBackInput!: ElementRef<HTMLInputElement>;

  // nicFrontFile: File | null = null;
  // nicBackFile: File | null = null;

  // nicFrontPreview: string | null = null;
  // nicBackPreview: string | null = null;

  ngOnInit() {
    this.regform = this.formBuilder.group({
      fname: ['', [Validators.required, Validators.minLength(2),Validators.pattern('^[a-zA-Z ]*$')]],
      sname: ['', [Validators.required, Validators.minLength(2),Validators.pattern('^[a-zA-Z ]*$')]],
      nic: ['', [Validators.required, Validators.pattern('^[0-9]{9}$|^[0-9]{12}$')]],
      // nicFront: [null, Validators.required],
      // nicBack: [null, Validators.required]
    })

    this.regform2 = this.formBuilder.group({
      address1: ['', [Validators.required, Validators.minLength(2)]],
      address2: ['', [Validators.required, Validators.minLength(2)]],
      suburb: ['', [Validators.required, Validators.minLength(2)]],

    })
    // zip: ['', [Validators.required, Validators.maxLength(5),Validators.minLength(5)]],

    this.regform3 = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]],
      phone: ['', [Validators.required, Validators.maxLength(10),Validators.minLength(10),Validators.pattern('^[0-9]+$')]],

    })

  }

  //register popup close
  dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }

  //country sri lanka clicked method
  click_lanka(){
    this.countryname.nativeElement.innerHTML="Sri Lanka";
    this.flug.nativeElement.src='../../../assets/images/sri-lanka.png';
  }

  //open login popup
  async launchLogin()
   {
    this.dismiss();
    const modal = await this.modalController.create({
      component: LoginComponent,
      cssClass: "customPopup",
    });
    
    //console.log("Place A");
    return await modal.present();
    
  }

  //open term and conditions popup
  async launchBookOfRules() {
    const modal = await this.modalController.create({
      component: TermsAndConditionsComponent,
      cssClass: "customPopup",
    });
    return await modal.present();
  }

  //open reset password popup
  async resetPassword() {
    const modal = await this.modalController.create({
      component: ResetPasswordComponent,
      cssClass: "customPopup",
    });
    return await modal.present();
  }

  //go to steps using bottom bttons
  goto_step1() {
    this.step1 = true;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;
  }

  // async onNicFrontSelected(event: any) {
  //   const input = event.target as HTMLInputElement;

  //   // User cancelled file picker
  //   if (!input.files || input.files.length === 0) {
  //     return;
  //   }

  //   const originalFile = input.files[0];

  //   try {
  //     const jpegFile = await this.convertToJpegAndResize(originalFile);

  //     this.regform.get('nicFront')?.setValue(jpegFile);
  //     this.regform.get('nicFront')?.markAsTouched();

  //     this.previewImage(jpegFile, 'front');

  //   }catch(err){
  //     console.error('Image conversion failed', err);
  //     this.regform.get('nicFront')?.setErrors({ 'conversionFailed': true });
  //     this.regform.get('nicFront')?.markAsTouched();
  //   }
  // }
  
  // async onNicBackSelected(event: any) {
  //   const input = event.target as HTMLInputElement;

  //   if (!input.files || input.files.length === 0) {
  //     return;
  //   }

  //   const originalFile = input.files[0];

  //   try {
  //     const jpegFile = await this.convertToJpegAndResize(originalFile);

  //     this.regform.get('nicBack')?.setValue(jpegFile);
  //     this.regform.get('nicBack')?.markAsTouched();

  //     this.previewImage(jpegFile, 'back');

  //   }catch(err){
  //     console.error('Image conversion failed', err);
  //     this.regform.get('nicBack')?.setErrors({ 'conversionFailed': true });
  //     this.regform.get('nicBack')?.markAsTouched();
  //   }
  // }
  
  // previewImage(file: File, side: 'front' | 'back') {
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     side === 'front'
  //       ? this.nicFrontPreview = reader.result as string
  //       : this.nicBackPreview = reader.result as string;
  //   };
  //   reader.readAsDataURL(file);
  // }
  
  // /* REMOVE FUNCTIONS */
  // removeNicFront() {
  //   this.nicFrontPreview = null;

  //   this.regform.get('nicFront')?.reset();

  //   this.regform.get('nicFront')?.markAsTouched();

  //   // reset file input
  //   if (this.nicFrontInput) {
  //     this.nicFrontInput.nativeElement.value = '';
  //   }
  // }
  
  // removeNicBack() {

  //   this.nicBackPreview = null;

  //   this.regform.get('nicBack')?.reset();

  //   this.regform.get('nicBack')?.markAsTouched();

  //   if (this.nicBackInput) {
  //     this.nicBackInput.nativeElement.value = '';
  //   }
  // }

  // convertToJpegAndResize(file: File, quality = 0.65, maxWidth = 1200, maxHeight = 1200): Promise<File> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  
  //     reader.onload = () => {
  //       const img = new Image();
  
  //       img.onload = () => {
  //         let width = img.width;
  //         let height = img.height;

  //         // Resize logic
  //         if (width > maxWidth || height > maxHeight) {
  //           const ratio = Math.min(maxWidth / width, maxHeight / height);
  //           width = Math.round(width * ratio);
  //           height = Math.round(height * ratio);
  //         }
        
  //         const canvas = document.createElement('canvas');
  //         canvas.width = width;
  //         canvas.height = height;

  //         const ctx = canvas.getContext('2d');
  
  //         if (!ctx) {
  //           reject('Canvas not supported');
  //           return;
  //         }
  
  //         ctx.drawImage(img, 0, 0, width, height);
  
  //         canvas.toBlob(
  //           blob => {
  //             if (!blob) {
  //               reject('Conversion failed');
  //               return;
  //             }
  
  //             const jpegFile = new File(
  //               [blob],
  //               file.name.replace(/\.\w+$/, '.jpg'),
  //               { type: 'image/jpeg' }
  //             );
  
  //             resolve(jpegFile);
  //           },
  //           'image/jpeg',
  //           quality
  //         );
  //       };
  
  //       img.onerror = reject;
  //       img.src = reader.result as string;
  //     };
  
  //     reader.onerror = reject;
  //     reader.readAsDataURL(file);
  //   });
  // }  

  isEnglish=/^[A-Za-z0-9 ,\.,/-]+$/
  goto_step2() {
    if(this.isEnglish.test(this.firstName) && this.isEnglish.test(this.surname)){
      // if(this.defaultFilter.isProfane(this.firstName) || this.defaultFilter.isProfane(this.surname)){
      //   let alert = new AlertComponent(this.alertController);
      //   alert.loginSuccessAlert("", "Profanity Word Found", "Please Don't Use Profanity Words");
      // }else{
      //   this.step1 = false;
      //   this.step2 = true;
      //   this.step3 = false;
      //   this.step4 = false;
      // }

      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
      this.step4 = false;
    }else{
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", "Unsupported Language", "Please Use English Letters");
    }

  }

  goto_step3() {
    if(this.isEnglish.test(this.address1) && this.isEnglish.test(this.address2) && this.isEnglish.test(this.suburb)){
      // if(this.defaultFilter.isProfane(this.address1) || this.defaultFilter.isProfane(this.address2) || this.defaultFilter.isProfane(this.suburb)){
      //   let alert = new AlertComponent(this.alertController);
      //   alert.loginSuccessAlert("", "Profanity Word Found", "Please Don't Use Profanity Words");
      // }else{
      //   this.step1 = false;
      //   this.step2 = false;
      //   this.step3 = true;
      //   this.step4 = false;
      // }
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
        this.step4 = false;
    }else{
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", "Unsupported Language", "Please Use English Letters");
    }
  }

  goto_step4() {
    // if(this.defaultFilter.isProfane(this.email)){
    //   let alert = new AlertComponent(this.alertController);
    //   alert.loginSuccessAlert("", "Profanity Word Found", "Please Don't Use Profanity Words");
    // }else{
    //   this.step1 = false;
    //   this.step2 = false;
    //   this.step3 = false;
    //   this.step4 = true;
    // }
      this.step1 = false;
      this.step2 = false;
      this.step3 = false;
      this.step4 = true;

  }


  //goto steps using top green icons
  top_goto_step2(event){
    this.renderer.addClass(event.target, 'active');
    if(this.errorControl.nic.errors || this.errorControl.fname.errors || this.errorControl.sname.errors){

    }else{
      
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
      this.step4 = false;
    }
  }

  top_goto_step3(){
    if(this.errorControl2.address1.errors || this.errorControl2.address2.errors || this.errorControl2.suburb.errors){

    }else{
      this.step1 = false;
      this.step2 = false;
      this.step3 = true;
      this.step4 = false;
    }
  }

  top_goto_step4(){
    if(this.errorControl3.email.errors || this.errorControl3.phone.errors){

    }else{
      this.step1 = false;
      this.step2 = false;
      this.step3 = false;
      this.step4 = true;
    }
  }

  //show alert
  successfullyRegister(email:any) {
    this.dismiss();
    let alert = new AlertComponent(this.alertController);
    alert.loginSuccessAlert("", "Registered", "Activation Link has send to "+ email);
  }

  //show alert
  failed_Register(err) {
    let alert = new AlertComponent(this.alertController);
    alert.loginSuccessAlert("", "Register failed", err);
  }

  //register button clicked method
  temp_accountNumber;
  click_register() {
    this.presentLoading().then(() => {
      var regParams = new register_pObj();

      //get account number 
      this.auth.getTempAccountNumber().subscribe(
        async (res) => {
          //CR 15-09-2022 MS
          //regParams.accountNumber = res["data"];

          regParams.withdrawFromBank = this.withdrawFromBank;
          regParams.country = this.country;
          regParams.phoneCountryCode = this.phoneCountryCode;
          regParams.countryCode = this.countryCode;
          regParams.currencyCode = this.currencyCode;
          regParams.emailAddress = this.emailAddress;
          regParams.pinNumber = this.pinNumber;
          regParams.title = this.title;

          regParams.firstName = this.firstName;
          regParams.surname = this.surname;
          regParams.idNumber = Number(this.idNumber);
          regParams.address1 = this.address1;
          regParams.address2 = this.address2;
          regParams.suburb = this.suburb;
          //regParams.postalCode = Number(this.postalCode); CR 18-3-25 
          regParams.postalCode = Number("00300");
          regParams.email = this.email;
          regParams.phoneNumber = Number(this.phoneNumber);
          regParams.agreeToTerms = this.agreeToTerms;
          regParams.cardType = this.cardType;
          regParams.cardNumber = this.cardNumber;
          regParams.cardExpireDate = this.cardExpireDate;
          regParams.cardExpireDateMMYY = this.cardExpireDateMMYY;
          regParams.cardSecurityCode = this.cardSecurityCode;
          regParams.balance = this.balance;
          regParams.customerIdType = this.customerIdType;
          regParams.customerIdReference = this.customerIdReference;

          // const nicFrontFile = this.regform.get('nicFront')?.value;
          // const nicBackFile  = this.regform.get('nicBack')?.value;

          // if (nicFrontFile) {
          //   regParams.nicFrontImage = await this.fileToBase64(nicFrontFile);
          // }

          // if (nicBackFile) {
          //   regParams.nicBackImage = await this.fileToBase64(nicBackFile);
          // }

          //console.log(regParams);

          this.auth.registerService(regParams).subscribe(
            (data) => {

              if (data.status == 'success') {
                //this.pinNumber = data.values.pinNumber;
                this.storageService.localStore("accountNo", regParams.accountNumber);
                var loginDataSessionString = this.storageService.getLocal("accountNo");
                this.loadingController.dismiss();
                this.successfullyRegister(regParams.email);
              } else {
                this.loadingController.dismiss();
                this.failed_Register(data.reason);
              }

            },
            (error) => {
              //console.log(error);
              this.loadingController.dismiss();
              let alert = new AlertComponent(this.alertController);
              alert.loginSuccessAlert("", "Register failed", "Register failed please try again..");
            }
          );


        },
        (error) => {
          this.loadingController.dismiss();
          //console.log(error);
        }
      );

    })

  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Please wait...',
      translucent: true,
    });
    return await loading.present();
  }

  // fileToBase64(file: File): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  
  //     reader.onload = () => {
  //       const base64 = (reader.result as string).split(',')[1]; // remove prefix
  //       resolve(base64);
  //     };
  
  //     reader.onerror = error => reject(error);
  //   });
  // }  


}
